import { warStateForWire } from "./socialDepth";
import { LS } from './storage';
import { APP_VERSION } from './sync';
import { normalizeBackupHealth } from './healthWire';

// The one backup shape the app knows how to read back. Settings → Export and
// Backup & Restore → Export both produce this; Backup & Restore → Import consumes it
// (top-level state keys, see IMPORTABLE_KEYS in state/reducer.js). Gamification
// state lives in localStorage rather than reducer state, so it is bundled alongside.
export function buildBackupPayload(s) {
  const health = normalizeBackupHealth({
    phases: s.phases || [],
    injuries: s.injuries || [],
  });
  return {
    _ironlog: { version: APP_VERSION, exported: new Date().toISOString(), platform: `IRONLOG v${APP_VERSION}` },
    workouts: s.workouts || [],
    nutrition: s.nutrition || [],
    body: s.body || [],
    exercises: s.exercises || [],
    goals: s.goals || {},
    schedule: s.schedule || {},
    units: s.units || "lbs",
    photos: s.photos || [],
    profile: s.profile || {},
    checkins: s.checkins || [],
    milestones: s.milestones || [],
    phases: health.phases || [],
    injuries: health.injuries || [],
    syncPrefs: s.syncPrefs,
    a11y: s.a11y,
    // Gamification state
    xp_bonus: LS.get("ft-xp-bonus"),
    missions_completed: LS.get("ft-missions-completed"),
    streak_shields: LS.get("ft-streak-shields"),
    shield_used_date: LS.get("ft-shield-used-date"),
    shield_awarded_streak: LS.get("ft-shield-awarded-streak"),
    comeback_used: LS.get("ft-comeback-used"),
    last_known_level: LS.get("ft-last-known-level"),
    duels: LS.get("ft-duels"),
    rivals: LS.get("ft-rivals"),
    ...warStateForWire(LS),
    war_wins: LS.get("ft-war-wins"),
    war_streak: LS.get("ft-war-streak"),
  };
}
